import * as p from '@clack/prompts'
import pc from 'picocolors'

export function printManualDeployHint(): void {
  p.log.info(`You can deploy manually: ${pc.cyan('vercel deploy --prod')}`)
}
